import { useCallback, useEffect, useRef, useState } from "react";
import type { AppScreen } from "../shared/types/contracts";
import type {
  DefenseExportView,
  ManagementConfirmation,
  TeamUiStateBase,
} from "./teamTypes";

export function useTeamUiState(): TeamUiStateBase {
  const [screen, setScreen] = useState<AppScreen>("setup");
  const [confirmAction, setConfirmAction] =
    useState<ManagementConfirmation>(null);
  const [manageOpen, setManageOpen] = useState(false);
  const [expandedPlayer, setExpandedPlayer] = useState<string | null>(null);
  const [confirmDelete, setConfirmDelete] = useState<string | null>(null);
  const [showLegend, setShowLegend] = useState(false);
  const [logOpen, setLogOpen] = useState(false);
  const [toast, setToast] = useState<string | null>(null);
  const [exportView, setExportView] = useState<DefenseExportView>("mobile");
  const [fieldInning, setFieldInning] = useState(0);
  const [defInning, setDefInning] = useState(0);
  const [selectedResultGameId, setSelectedResultGameId] = useState<
    string | null
  >(null);
  const toastTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback((message: string) => {
    setToast(message);
    if (toastTimer.current !== null) clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 2600);
  }, []);

  useEffect(
    () => () => {
      if (toastTimer.current !== null) clearTimeout(toastTimer.current);
    },
    [],
  );

  return {
    screen,
    setScreen,
    confirmAction,
    setConfirmAction,
    manageOpen,
    setManageOpen,
    expandedPlayer,
    setExpandedPlayer,
    confirmDelete,
    setConfirmDelete,
    showLegend,
    setShowLegend,
    logOpen,
    setLogOpen,
    toast,
    showToast,
    exportView,
    setExportView,
    fieldInning,
    setFieldInning,
    defInning,
    setDefInning,
    selectedResultGameId,
    setSelectedResultGameId,
  };
}
